import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./query-client";
import { MainLayout } from "./main-layout";
import { MeContext } from "../contexts/me-context/me-context";
import { Toaster } from "../components/ui/sonner";
import { App as AntdApp } from "antd";
import { TooltipProvider } from "../components/ui/tooltip";
import { api } from "../services/api";
import { mergeSessionUser, getStoredUser } from "../utils/session-user";
import { UserModel } from "../types/user";

function App() {
    const [me, setMe] = useState<UserModel | null>(null);
    // Começa true: enquanto não sabemos se há sessão pra revalidar, RequirePermission
    // não pode decidir (senão redireciona antes do /user/me trazer roles/permissions atuais).
    const [meLoading, setMeLoading] = useState(true);
    const [role, setRole] = useState<{ id: string | null }>({ id: null });
    const [filter, setFilter] = useState({
        masterIndex: {},
    });
    useEffect(() => {
        const storedUser = getStoredUser();
        setMe(storedUser);
        let storedRole = { id: null };
        try {
            const activeRoleAux = localStorage.getItem("active_role");
            if (activeRoleAux) storedRole = JSON.parse(activeRoleAux);
        } catch {
            /* corrupt active_role in storage — fall back to empty role */
        }
        setRole(storedRole);

        // Refresh from the authoritative source so name/avatar reflect the backend, not a stale snapshot.
        if (storedUser?.id) {
            api.get("/user/me", { hideErrorToast: true })
                .then(({ data }) => {
                    const fresh = data?.data ?? data;
                    if (fresh?.id) {
                        const merged = mergeSessionUser(storedUser, fresh);
                        setMe(merged);
                        localStorage.setItem("user", JSON.stringify(merged));
                    }
                })
                .catch(() => {
                    /* keep the stored snapshot if the refresh fails */
                })
                .finally(() => setMeLoading(false));
        } else {
            setMeLoading(false);
        }
    }, []);
    return (
        <QueryClientProvider client={queryClient}>
            <MeContext.Provider value={{ me, setMe, meLoading }}>
                <TooltipProvider>
                    <AntdApp>
                        <BrowserRouter>
                            <MainLayout me={me} role={role} />
                        </BrowserRouter>
                        <Toaster
                            position="bottom-right"
                            richColors
                            expand={true}
                        />
                    </AntdApp>
                </TooltipProvider>
            </MeContext.Provider>
        </QueryClientProvider>
    );
}

export default App;
